import { ExpressionKinds } from "./ExpressionKinds";
import { IExpressionBehavior } from "./IExpressionBehavior";

export interface IExpressionBehaviorSpecifiable {
  expressionKind: ExpressionKinds;
  expressionBehavior: IExpressionBehavior;
}

export function instanceOfIExpressionBehaviorSpecifiable(instance: any): instance is IExpressionBehaviorSpecifiable {
  return instance
      && (instance.expressionKind !== undefined)
      && (instance.expressionBehavior !== undefined);
}
